export default __webpack_public_path__ + "static/media/2018_4.16981463.jpg";